import PortalVue from 'portal-vue';
import Vue from 'vue';
import VueMeta from 'vue-meta';
import { SelfServeApiPlugin, } from '~/api/self-serve-api';
import type { ConfigValueAccessor, } from '~/utils/self-serve/global-config';
import { loadGlobalConfig, } from '~/utils/self-serve/global-config';
import App from './app.vue';
import { Router, } from './router';
import { Store, } from './store';
import '~/assets/scss/self-serve.scss';
import '~/assets/scss/fontawesome.scss';

Vue.config.productionTip = false;
Vue.use(VueMeta);

const router = Router;
Vue.use(PortalVue);

export function MoveOut(mountPoint: string | HTMLElement, configValueAccessor: ConfigValueAccessor) {
	const globalConfig = loadGlobalConfig(configValueAccessor);
	Vue.use(SelfServeApiPlugin, {
		baseUrl: globalConfig.SelfServeApiAddress || '',
	});

	Store.commit.hydrateGlobalConfig(globalConfig);

	new Vue({
		router,
		render(h) {
			return h(App);
		},
		store: Store.original,
	}).$mount(mountPoint);
}
